import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {ApiResponseModel, ApiVisa, BaseApiTemplateService} from '../shared';
import {Core2Config} from '../shared';
import {AppLoginPrincipalContainerModel} from '../../../../../models/aggregates/app-login';
import {AccessKeyPostRequestModel} from '../../../../../models/aggregates/custom/platform';
import { Observable } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class AccessKeyService extends BaseApiTemplateService<AccessKeyPostRequestModel> {

  readonly url = Core2Config.DOMAIN_URL + Core2Config.PLATFORM_DOMAIN_URL_PREFIX + 'identity/access-keys';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.PLATFORM_DOMAIN_URL_PREFIX + 'identity/access-keys';
    this.endpoint_path = Core2Config.PLATFORM_DOMAIN_URL_PREFIX + 'identity/access-keys';
    this.httpClient = http;
  }

  public postWithLoginEp(dtoObject: AccessKeyPostRequestModel, visa: ApiVisa): Observable<ApiResponseModel<AccessKeyPostRequestModel>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }

    const url = this.apiUrl + '/login-ep';
    return this.httpClient.post<ApiResponseModel<AccessKeyPostRequestModel>>(
      url,
      dtoObject,
      this.getHttpHeader(visa)
    );
  }

  public getWithLoginEp(visa: ApiVisa): Observable<ApiResponseModel<AppLoginPrincipalContainerModel>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }

    const url = this.apiUrl + '/login-ep';
    return this.httpClient.get<ApiResponseModel<AppLoginPrincipalContainerModel>>(
      url,
      this.getHttpHeader(visa)
    );
  }

  public deleteWithLoginEp(guid: string, visa: ApiVisa): Observable<ApiResponseModel<boolean>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }

    const url = this.apiUrl + '/login-ep';
    return this.httpClient.delete<ApiResponseModel<boolean>>(
      url + '/' + guid,
      this.getHttpHeader(visa)
    );
  }

}
